import React, { useContext } from 'react';
import { useDispatch, useSelector } from "react-redux";

import _ from 'lodash';
import cx from 'classnames';
import { Frame } from 'scenejs';

import { EditorContext } from '../../index';
import { Property } from '../../components/properties/';

import styles from './liveElements.module.scss';
import { useState } from 'react';
import { updateWidgetProperty } from 'actions/editor';
import { PageWidgetContext } from '../page';

const LiveElementContainerWidget = function ({ widgetProps, widgetRef, className, style, children }) {
  const ref = widgetRef;
  const dispatch = useDispatch();

  const editorContext = React.useContext(EditorContext);
  const editor = editorContext.editorSession.id;

  const [elementWidgetContext, setElementWidgetContext] = useState({
    onResize: () => { }
  });

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const breakpoint = useSelector(state => _.get(state, `${editor}.present.breakpoint`));
  const tools = useSelector((state) => _.get(state, `${editor}.present.tools`));

  const offset = breakpoint === 'desktop' ? 100 : 100;

  const visibleWitdh = breakpoint === 'desktop' ? 1200 : 375;
  const widgetHeight = Math.max(parseInt(_.get(widgetProps, `properties.${breakpoint}.layout.height`)) || 0, 600);
  const [height, setHeight] = useState(widgetHeight);

  var widgetStyle = {
    ...style,
    transform: 'translate(0px, 0px) rotate(0deg) scale(1, 1)'
  }

  const handleResize = () => {
    var height = 0;
    const parentRect = widgetRef.current.getBoundingClientRect();

    const editorWidgetViewer = document.getElementsByClassName('editor_widget_viewer')[0];

    const widgets = editorWidgetViewer.querySelectorAll(`#${id} .widget[data-widget-id]`);
    Array.from(widgets).forEach(element => {
      const rect = element.getBoundingClientRect();
      height = Math.max(height, rect.bottom - parentRect.top);
    });

    height = Math.max(600, height);
    setHeight(`${height}px`);
  };

  React.useEffect(() => {
    setElementWidgetContext({
      onResize: handleResize
    });
  }, []);

  React.useEffect(() => {
    const layout = _.get(widgetProps, `properties.${breakpoint}.layout`) || {};
    if (layout && layout.height != height) {
      dispatch(updateWidgetProperty(editor, id, breakpoint, {
        layout: {
          ...layout,
          height: height
        }
      }))
    }
  }, [height]);

  return (
    <>
      <PageWidgetContext.Provider value={elementWidgetContext}>
        <div id={id}
          ref={ref}
          className={cx(className, styles.liveElementContainer, 'cs_live_element_container', {
            [styles.mobile]: breakpoint === 'mobile'
          })}
          data-widget-id={id}
          data-widget-type={type}
          data-container={true}
          data-selectable={false}
          style={widgetStyle}
        >
          {children}
        </div>
      </PageWidgetContext.Provider>

      {tools.gridlines &&
        <>
          <div className={cx(styles.boundary, styles.top)} style={{
            top: offset
          }} />
          <div className={cx(styles.boundary, styles.bottom)} style={{
            top: `${widgetHeight + offset}px`
          }} />

          <div className={cx(styles.boundary, styles.left)} style={{
            left: `calc((100% - ${visibleWitdh}px)/2)`,
            height: `${widgetHeight + 300}px`
          }} />
          <div className={cx(styles.boundary, styles.right)} style={{
            right: `calc((100% - ${visibleWitdh}px)/2)`,
            height: `${widgetHeight + 300}px`
          }} />
        </>
      }
    </>
  )
}

const LiveElementContainerDesktopAction = (props) => {
  const dispatch = useDispatch();

  return (
    <>
      <Property.Action onClick={() => { window.open(`${process.env.REACT_APP_CLEVERSTORY_SUPPORT}`, '_blank') }} className={styles.iconButton}>
        <i className={'cleverstory-help'} />
      </Property.Action>
    </>
  );
}

LiveElementContainerWidget.moveableConfig = (editorSession, widget) => {
  return {
    draggable: false,
    resizable: false,
    rotatable: false,
    selectable: false,
    cloneable: false,
    deletable: false
  }
}

LiveElementContainerWidget.actions = (editor, breakpoint, props) => {
  return (
    <LiveElementContainerDesktopAction
      editor={editor}
      breakpoint={breakpoint}
      {...props}
    />
  );
}

export { LiveElementContainerWidget }